import { Api as KyousouApi } from '../clients/kyousou_api_client'
import { Api as KuchikomiApi } from '../clients/kuchikomi_api_client'
import { ServerityType } from '../providers/snack_bar_provider'

/**
 * APIクライアントを作成する関数。リクエスト時に使用する共通の設定を含む。
 * @returns APIクライアント
 */
export const getKuchikomiApiClient = (): KuchikomiApi<unknown> => {
  const token = window.localStorage.getItem('ACCESS-TOKEN')

  return new KuchikomiApi({
    baseUrl: process.env.REACT_APP_KUCHIKOMI_API_BASE_URL,
    baseApiParams: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  })
}

/**
 * APIクライアントを作成する関数。リクエスト時に使用する共通の設定を含む。
 * @returns APIクライアント
 */
export const getKyousouApiClient = (): KyousouApi<unknown> => {
  const token = window.localStorage.getItem('ACCESS-TOKEN')
  return new KyousouApi({
    baseUrl: process.env.REACT_APP_KYOUSOU_API_BASE_URL,
    baseApiParams: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  })
}

/**
 * APIのエラーレスポンスの型定義。レスポンスの中に含まれるエラー情報を格納。
 */
export interface ApiErrorResponse extends Response {
  error: {
    errors: {
      [key: string]: string[]
    }
    message: string | null
    error_code?: string
  }
}

/**
 * APIエラーハンドリング用の関数。エラー内容に応じて適切なエラーメッセージを表示する。
 * @param errorResponse エラーレスポンス
 * @param showSnackBar スナックバーを表示する関数
 * @param onPlanRequired プラン登録が必要な場合に実行されるコールバック関数（オプション）
 */
export const handleError = (
  errorResponse: ApiErrorResponse,
  showSnackBar: (messages: string[], type: ServerityType) => void,
  onPlanRequired?: () => void
) => {
  // プラン登録が必要なエラーの場合
  if (
    (errorResponse.status === 403 &&
      errorResponse.error.error_code === 'PLAN_REQUIRED') ||
    errorResponse.error.error_code === 'FREE_PLAN_LIMIT_EXCEEDED'
  ) {
    if (onPlanRequired) {
      onPlanRequired()
    } else {
      // コールバックが指定されていない場合はスナックバーで表示
      showSnackBar(
        [
          'プラン登録が必要な処理です。サイドメニュー「サービス連携」->「ダッシュボード」からプランを登録してください。',
        ],
        'error'
      )
    }
    return
  }

  // サーバー側のエラー（ステータスコード500）の場合
  if (errorResponse.status === 500) {
    showSnackBar(
      [
        'エラーが発生しました。お手数ですがお問い合わせよりお問い合わせください。',
      ],
      'error'
    )
  } else if (errorResponse.status === 400) {
    if (Object.keys(errorResponse.error.errors).length > 0) {
      showSnackBar(Object.values(errorResponse.error.errors).flat(), 'error')
    } else if (errorResponse.error.message) {
      showSnackBar([errorResponse.error.message], 'error')
    } else {
      showSnackBar(
        [
          'エラーが発生しました。お手数ですがお問い合わせよりお問い合わせください。',
        ],
        'error'
      )
    }
  } else if (errorResponse.status === 413) {
    showSnackBar(['ファイルサイズが大きすぎます。'], 'error')
  } else {
    console.error(errorResponse)
    showSnackBar(
      ['エラーが発生しました。通信環境をご確認の上、再度お試しください。'],
      'error'
    )
  }
}
